var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIOs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.62 16.54C20.64 15.22 21.33 14 22.45 13.31C21.74 12.29 20.59 11.67 19.35 11.63C18.04 11.49 16.78 12.41 16.11 12.41C15.44 12.41 14.41 11.64 13.3 11.67C11.85 11.72 10.53 12.52 9.81998 13.79C8.31998 16.39 9.43998 20.22 10.88 22.32C11.6 23.35 12.44 24.5 13.54 24.46C14.62 24.42 15.02 23.77 16.32 23.77C17.62 23.77 17.99 24.46 19.11 24.43C20.27 24.41 21 23.4 21.69 22.35C22.21 21.62 22.61 20.8 22.87 19.95C21.5 19.37 20.6 18.02 20.6 16.53L20.62 16.54Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.49 10.25C19.12 9.49004 19.43 8.52004 19.36 7.54004C18.4 7.64004 17.51 8.10004 16.87 8.83004C16.24 9.55004 15.92 10.49 15.98 11.44C16.96 11.44 17.88 11.01 18.5 10.25H18.49Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIOs);
export default __webpack_public_path__ + "static/media/profile_iOS.39cbb33acda3ed915b63a4312970c1c6.svg";
export { ForwardRef as ReactComponent };